<template>
    <v-container class="affiliate-container">

     


      <div>
        <h1>{{ $lang.affiliate.page_title }}</h1>
        <p class="mb-4 description">
            {{ $lang.affiliate.page_description }}
        </p>






        <div class="affiliate-page-group top flex">
                <div class="affiliate-page-container col-md-4 col-sm-12 col-xs-12">
                     <div class="affiliate-page-group-header">
                      
                       <img alt="affiliate sign up" :src='"@/assets/images/affiliate/step1.webp"'>
                       <h2 class="affiliate-page-group-title" v-html="$lang.affiliate.step1">
                        
                        </h2>
                        <h3 v-html="$lang.affiliate.step1_desc">
                        </h3>
                      
                    </div>
                </div>
                <div class="affiliate-page-container col-md-4 col-sm-12 col-xs-12">
                     <div class="affiliate-page-group-header">
                      
                        <img alt="affiliate share your custom link" :src='"@/assets/images/affiliate/step2.webp"'>
                        <h2 class="affiliate-page-group-title" v-html="$lang.affiliate.step2">
                        </h2>
                        <h3 v-html="$lang.affiliate.step2_desc">
                        </h3>
                     
                    </div>
                </div>

                <div class="affiliate-page-container col-md-4 col-sm-12 col-xs-12">
                     <div class="affiliate-page-group-header">
                        
                        <img alt="affiliate earn money" :src='"@/assets/images/affiliate/step3.webp"'>
                        <h2 class="affiliate-page-group-title" v-html="$lang.affiliate.step3">
                        </h2>
                        <h3 v-html="$lang.affiliate.step3_desc">
                        </h3>
                     
                    </div>
                </div>
            </div>


        <v-card class="pa-6">
          <!-- <h1>Join the Taption Affiliate Program</h1>
          <p class="mb-4">
            Introduce new customers to Taption. Share your unique affiliate link and earn commission 
            for every successful referral. Let's grow together!
          </p>        :rules="phoneRules"-->
    
          <v-form ref="form" class="affiliate-form" v-model="valid" :disabled="isSubmitting">
            <h3 class="mb-4">{{ $lang.affiliate.tell_us_about_yourself }}</h3>
            
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.firstName"
                  :label="$lang.affiliate.first_name"
                  :rules="nameRules"
                  required
                  solo
                  flat
                  dense
                  autocomplete="given-name"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.lastName"
                  :label="$lang.affiliate.last_name"
                  :rules="nameRules"
                  required
                  solo
                  flat
                  dense
                  autocomplete="family-name"
                ></v-text-field>
              </v-col>
            </v-row>
    
            <v-text-field
              v-model="formData.businessName"
              :label="$lang.affiliate.business_name"
              solo
              flat
              dense
              autocomplete="organization"
            ></v-text-field>
    
            <v-text-field
              v-model="formData.location"
              :label="$lang.affiliate.location"
              :rules="[v => !!v || $lang.affiliate.location_required_err]"
              required
              solo
              flat
              dense
              autocomplete="street-address"
            ></v-text-field>
    
            <h3 class="mt-6 mb-4">{{ $lang.affiliate.contact }}</h3>
            
            <v-row>
              <v-col cols="12" md="6" class="contact">
                <v-text-field
                  v-model="formData.email"
                  :label="$lang.affiliate.email"
                  :rules="emailRules"
                  required
                  solo
                  flat
                  dense
                  autocomplete="email"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6" class="contact">
                <v-text-field
                  v-model="formData.phone"
                  :label="$lang.affiliate.phone"
          
                  solo
                  flat
                  dense
                  autocomplete="tel"
                ></v-text-field>
              </v-col>
            </v-row>
    
            <v-row>
              <v-col cols="12" md="6" class="contact">
                <v-text-field
                  v-model="formData.linkedin"
                  :label="$lang.affiliate.linkedin_url"
                  solo
                  flat
                  dense
                  autocomplete="url"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6" class="contact">
                <v-text-field
                  v-model="formData.social"
                  :label="$lang.affiliate.social_url"
                  solo
                  flat
                  dense
                  autocomplete="username"
                ></v-text-field>
              </v-col>
            </v-row>
    
            <h3 class="mt-6 mb-4">{{ $lang.affiliate.tell_us_about_site }}</h3>
            
            <v-text-field
              v-model="formData.website"
              :label="$lang.affiliate.website_url"
              :rules="urlRules"
              required
              solo
              flat
              dense
              autocomplete="url"
            ></v-text-field>
    
            <v-select
              v-model="formData.traffic"
              :items="trafficOptions"
              :label="$lang.affiliate.traffic"
              required
              :rules="[v => !!v || $lang.affiliate.estimate_traffic_err]"
              solo
              flat
              dense
            ></v-select>
    
            <v-textarea
              v-model="formData.siteDescription"
              :label="$lang.affiliate.what_site_about"
              rows="3"
              :rules="[v => !!v || $lang.affiliate.describe_site_err]"
              required
              solo
              flat
              dense
            ></v-textarea>
            
            <v-textarea
              v-model="formData.additionalInfo"
              :label="$lang.affiliate.anything_else"
              rows="3"
              solo
              flat
              dense
            ></v-textarea>
    
            <v-checkbox
            class="understand-terms"
              v-model="formData.terms"
              :rules="[v => !!v || $lang.affiliate.must_agree]"
              required
            >
              <template v-slot:label>
                {{ $lang.affiliate.read_agree }}
                <a @click="onTermsClicked" style="margin-left:5px; cursor: pointer;">{{ $lang.affiliate.affiliate_tos }}</a>
              </template>
            </v-checkbox>  
    
            
            <v-btn
              :loading="isSubmitting"
              @click="submitForm"
              class="custom-button mt-4"
              :rules="[v => !valid || $lang.affiliate.describe_site_err]"
            >
            {{ $lang.affiliate.submit }}
            </v-btn>
            <div v-show="!!customErrorMessage" class="error-message" v-html="customErrorMessage"></div>
          </v-form>
        </v-card>
      </div>
    </v-container>
  </template>
  
  <script>
import userService from '@/connections/user.service';
  export default {
    data: () => ({
      valid: false,
      customErrorMessage:'',
      isSubmitting: false,
      formData: {
        id:'',
        firstName: '',
        lastName: '',
        businessName: '',
        location: '',
        email: '',
        phone: '',
        linkedin: '',
        social: '',
        website: '',
        traffic: '',
        siteDescription: '',
        additionalInfo: '',
        terms: false
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 50 || 'Name must be less than 50 characters'
      ],
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid'
      ],
      phoneRules: [
        v => !v || /^\d{10}$/.test(v.replace(/\D/g,'')) || 'Please enter valid phone number'
      ],
      urlRules: [
        v => !!v || 'Website URL is required',
        v => /^(http(s)?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/.test(v) || 'Please enter valid URL'
      ],
      trafficOptions: [
        '< 10,000',
        '10,000 - 50,000',
        '50,000 - 100,000',
        '100,000 - 500,000',
        '500,000+'
      ]
    }),
    computed:{
      termsUrl(){
        return window.location.origin + "/blog/en/affiliate-terms-en" ;
      }
    },
    methods: {
      async submitForm() {
        const me = this;
        if (me.$refs.form.validate()) {
            me.customErrorMessage = '';
            me.isSubmitting = true;
            const result = await userService.getGeoLocation();
            me.formData.location = result;
            await userService.reqeustAffiliate(me.formData);
            setTimeout(function(){
                me.$dialog.alert(me.$lang.affiliate.submit_success+'<div class="fading-line"></div>',{
                    customClass: 'taption-dialog alert',
                    okText: me.$lang.common.ok,
                    html:true
                }).then(function(){
                    window.location.reload();
                    me.isSubmitting = false;
                });
            }, 2000)
        }
        else{
          me.customErrorMessage = me.$lang.affiliate.generic_err;
        }
      },
      resetForm(){
        const me = this;
        me.formData = {
            id:'',
            firstName: '',
            lastName: '',
            businessName: '',
            location: '',
            email: '',
            phone: '',
            linkedin: '',
            social: '',
            website: '',
            traffic: '',
            siteDescription: '',
            additionalInfo: '',
            terms:''
        };
      },
      onTermsClicked(){
        try{
          window.open(this.termsUrl, '_blank').focus();
        }
        catch{
          window.location.href = this.termsUrl;
        }
      }
    },
    mounted(){
        const me = this;
        me.isSubmitting = false;
    },
    created(){
        const me = this;
    me.nameRules = [
        v => !!v || me.$lang.affiliate.name_required_err,
        v => v.length <= 50 || me.$lang.name_character_limit_err
      ];
      me.emailRules=  [
        v => !!v || me.$lang.affiliate.email_required_err,
        v => /.+@.+\..+/.test(v) || me.$lang.affiliate.email_invalid_err
      ];
      me.phoneRules=  [
        v => !v || /^\d{10}$/.test(v.replace(/\D/g,'')) || me.$lang.affiliate.phone_needed_err
      ];
      me.urlRules =  [
        v => !!v || me.$lang.affiliate.website_required_err,
        v => /^(http(s)?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/.test(v) || me.$lang.affiliate.invalid_website_err
      ];
    }
  }
  </script>
  
  <style scoped>
  .v-card {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .custom-button {
    background-color: #3ccebd !important;
    color: white !important;
    border-radius: 25px !important;
    text-transform: none !important;
  }
  
  .custom-link {
    color: #3ccebd !important;
    text-transform: none !important;
  }
  
  /* Optional: Add hover effects */
  .custom-button:hover {
    opacity: 0.9;
  }
  
  .custom-link:hover {
    text-decoration: underline;
  }

  .affiliate-form::v-deep .v-text-field--single-line.v-text-field--solo .v-input__slot{
    background-color:transparent;
  }


  .affiliate-form::v-deep .v-text-field__slot .v-label{
    padding:0px 10px;
    font-size:16px;
  }
  .affiliate-form::v-deep .v-select .v-label{
    left:10px!important;
    font-size:16px;
  }

  .affiliate-form::v-deep textarea,
  .affiliate-form::v-deep input{
    /* margin-bottom:0px;
    border-radius: 5px!important;
    padding:0px 10px!important;
    letter-spacing: 0px;
    font-size: 14px; */

    margin-bottom:0px;
    min-height: 42px;
    font-size: 16px;
    border: none;
    border-radius: 10px !important;
    padding:0px 10px!important;
    box-shadow: none;
    border: 1px solid #d3d3d3;
    width: 100%;
    transition: all .2s ease-in !important;
  }

  .affiliate-form .custom-link,
  .affiliate-form .custom-button{
    letter-spacing: 0px;
  }

  .affiliate-container{
    padding:150px 0px;
    background:rgba(216,240,236,.2);
  }

  .affiliate-container::before{
    content:"";
    background-image: url('../assets/images/login-background.webp')!important;
    background-repeat: repeat;
    opacity: 0.1;
    z-index: 0;
    background-size:contain;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
  }

  .affiliate-form::v-deep .v-select__selections{
    border-radius:25px!important;
    cursor: pointer;
    border: 1px solid #d3d3d3;
  }
  .affiliate-form::v-deep .v-select__selections input{
    border: 0px;
    cursor: pointer;
  }
  .affiliate-form::v-deep .v-select .v-input__append-inner{
    display:none;
  }

  .affiliate-form::v-deep .v-select__selection{
    margin-left:10px;
  }

  .affiliate-container::v-deep h1{
    /* letter-spacing: 2px; */
    /* width: 100%;
    font-size: 53px;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    color: #1c2d27 !important;
    text-align: center;
    margin-bottom:30px; */

    font-size: 53px;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
  }
  .affiliate-container h3{
    margin-top:0px;
  }
  .affiliate-container .description{
    font-size: 20px;
    padding: 0px 300px;
    margin-bottom:50px!important;
  }
  .affiliate-container .v-card{
    border-radius: 10px;
  }
  .affiliate-container .row > .contact{
    padding: 10px 12px;
  }
  
  /* Style for input fields */
  ::v-deep .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px;
  }
  
  ::v-deep .v-text-field.v-text-field--solo .v-input__slot {
    box-shadow: none;
    background: #f5f5f5;
  }
  
  /* Style for select field */
  ::v-deep .v-select.v-select--solo .v-input__slot {
    box-shadow: none;
    background: #f5f5f5;
  }
  
  /* Style for textarea */
  ::v-deep .v-textarea.v-textarea--solo .v-input__slot {
    box-shadow: none;
    background: #f5f5f5;
  }

  ::v-deep .mdi-checkbox-marked{
    border: 3px solid white;
    background: lightgray;
    padding: 2px;
    outline: 3px gray solid;
  }
  ::v-deep .mdi-checkbox-blank-outline{
    border: 1px solid white;
    background: white;
    padding: 2px;
    outline: 3px gray solid;
  }

  .understand-terms{
    padding-left: 20px;
  }

  .affiliate-page-group{
    margin-bottom: 20px;
  }

  .affiliate-page-group-header h2,
  .affiliate-page-group-header h3{
    letter-spacing: 0px;
    color:#425467;
    padding: 0px 20px;
    text-transform: none;
  }

  .affiliate-page-group img{
    max-width: 90%;
    max-height: 200px;
  }

  .affiliate-page-group.flex{
    display:flex;
  }

  h2.affiliate-page-group-title{
    font-size: 20px;
    letter-spacing: 0px;
    text-transform: capitalize;
  }

  .error-message{
    color:red;
    font-size: 12px;
  }
  
  </style>